import React, { useState, useEffect } from 'react';
import defaultPicture from '../assets/default.jpg';

const CustomImage = ({
  src, alt = '', style = {}, defaultSrc = defaultPicture,
  className = '', loading = false, base64 = false, onLoad, onError, ...rest
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(loading);

  useEffect(() => {
    if (src) { setImgSrc(src); setHasError(false); setIsLoading(loading); }
    else { setImgSrc(defaultSrc); setHasError(!defaultSrc); setIsLoading(false); }
  }, [src, defaultSrc, loading]);

  const finalSrc = base64 ? src : (hasError ? defaultSrc : imgSrc);
  if (!src && !defaultSrc) return null;

  return (
    <div style={{ position: 'relative', ...style }} className={className}>
      {isLoading && (
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg,#f0e8e0 25%,#e8ddd4 50%,#f0e8e0 75%)', backgroundSize: '200% 100%', animation: 'imgShimmer 1.4s infinite', zIndex: 1 }}/>
      )}
      <img
        src={finalSrc || defaultSrc} alt={alt} className={className}
        style={{ ...style, display: isLoading ? 'none' : undefined }}
        onError={e => { if (!hasError && imgSrc !== defaultSrc) { setImgSrc(defaultSrc); setHasError(true); onError?.(e); } setIsLoading(false); }}
        onLoad={e => { setIsLoading(false); onLoad?.(e); }}
        {...rest}
      />
    </div>
  );
};
export default CustomImage;
